import type { DetailedHTMLProps, InputHTMLAttributes, Ref } from 'react';
import { forwardRef } from 'react';

import TextInput from './TextInput';

function InnerTextInput(
  {
    error,
    ...props
  }: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
    error?: boolean;
  },
  ref: Ref<HTMLInputElement>,
) {
  return <TextInput {...props} ref={ref} error={error} className="pl-14" />;
}

export default forwardRef(InnerTextInput);
